import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type {
  IGetBankReport,
  ISearchReport,
  IGetExpenseReport,
  IGetRevenueReport,
  ISearchFormerTenantDebt,
} from "@/types/requests";
import type {
  IGetBankReportResponse,
  ISearchReportResponse,
  IGetExpenseReportResponse,
  IGetRevenueReportResponse,
  IFormerTenantDebtResponse,
} from "@/types/response";

class ReportService extends BaseHttp {
  async searchReport(body: ISearchReport) {
    const { data, success, error } = await this.post<ISearchReportResponse>(
      "/search",
      body,
      {
        requestKey: "searchReport",
      }
    );
    return { data, success, error };
  }

  async getBankReport(body: IGetBankReport) {
    const { data, success, error } = await this.post<IGetBankReportResponse>(
      "/search/banks",
      body,
      {
        requestKey: "getBankReport",
      }
    );
    return { data, success, error };
  }

  async getExpenseReport(body: IGetExpenseReport) {
    const { data, success, error } = await this.post<IGetExpenseReportResponse>(
      "/search/expenses",
      body,
      {
        requestKey: "getExpenseReport",
      }
    );
    return { data, success, error };
  }

  async getRevenueReport(body: IGetRevenueReport) {
    const { data, success, error } = await this.post<IGetRevenueReportResponse>(
      "/search/revenues",
      body,
      {
        requestKey: "getRevenueReport",
      }
    );
    return { data, success, error };
  }

  async getFormerTenantDebts(body: ISearchFormerTenantDebt, export_ = false) {
    const { data, success, error } = await this.post<IFormerTenantDebtResponse>(
      "/search/former-tenant-debts",
      body,
      {
        // Dışa aktarma isteği tablo isteğini iptal etmesin diye ayrı anahtar kullanır.
        requestKey: export_ ? "exportFormerTenantDebts" : "getFormerTenantDebts",
      }
    );
    return { data, success, error };
  }
}

export default new ReportService(apiGwClient, "/api/v1/reports");
